module.exports = __webpack_public_path__ + "static/media/test7_3.2250ee0e.png";